module.exports = __webpack_public_path__ + "static/media/qrcode.a4097930.jpg";